const initialState = {
  programmes: [],
  lots: [],
  deepSearchLots: [],
  deepSearchLotsPagination: {},
  deepSearchProgrammes: [],
  deepSearchProgrammesPagination: {},
  deepSearchLoading: false,
  deepSearchError: null,
  lotsLoading: false,
  lotsError: null,
  lotsPagination: {
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  },
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  },
  activeOnglet: {
    id: "stock",
    name: "stock",
    type: "stock",
    subtitle: " lots -  programmes",
    loading: true,
    error: null,
  },
  activeView: "lots",
  singleProgramId: null,
  cashedSinglePrograms: [],
  singleProgram: null,
  singleProgramLoading: false,
  singleProgramError: null,
  openPrograms: [],
  openProgramsData: {},
  openProgramsLoading: {},
  openProgramsError: {},
  openLots: [],
  openLotsData: {},
  openLotsLoading: {},
  openLotsError: {},
  singleLotId: null,
  singleLot: null,
  singleLotLoading: false,
  singleLotError: null,
  searchHistory: null,
  promoteursSearch: [],
  promoteursSearchLoading: false,
  promoteursSearchError: null,
  searchedPromoteurName: "",
  onglets: [
    {
      id: "stock",
      name: "stock",
      type: "stock",
      subtitle: "",
    },
  ],
};

const immobilierReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_NEW_ONGLET":
      const id = action.payload.id;
      const type = action.payload.type;
      const name = action.payload.name;
      const results = action.payload.results;
      const query = action.payload.query;
      const updateCard = action.payload.updateCard;

      const foundOnglet = state.onglets.find((onglet) => onglet.id === id);

      const newOnglet = type.includes("lot")
        ? { id, name, type, subtitle: "Lot", lot: results }
        : type.includes("programme")
          ? { id, name, type, subtitle: "Programme", programme: results }
          : {
              id,
              name,
              type,
              subtitle: `${results?.lots?.pagination?.total || 0} lots ${
                results?.programmes?.pagination?.total || 0
              } programmes`,
              programmesCoordinates: results.programmesCoordinates,
              lots: results.lots.results,
              lotsPagination: results.lots.pagination,
              programmes: updateCard
                ? foundOnglet.programmes
                : results.programmes.results,
              ...(updateCard
                ? { programmeListMap: results.programmes.results }
                : {}),
              ...(updateCard
                ? { programmeListMapPagination: results.programmes.pagination }
                : {}),
              programmesPagination: updateCard
                ? foundOnglet.programmesPagination
                : results.programmes.pagination,
              showModifyIcon: type === "search",
              query: query,
              //not used yet
              loading: false,
              error: null,
            };

      if (!foundOnglet) {
        return {
          ...state,
          activeOnglet: newOnglet,

          onglets: [...state.onglets, newOnglet],
        };
      } else {
        return {
          ...state,
          activeOnglet: newOnglet,
          onglets: state.onglets.map((onglet) => {
            if (onglet.id === id) {
              return {
                ...onglet,
                ...newOnglet,
              };
            }
            return onglet;
          }),
        };
      }

    case "FETCH_LOTS_SUCCESS":
      let found = state.onglets.find(
        (onglet) => onglet.id === action.payload.ongletId,
      );
      return {
        ...state,
        activeOnglet: {
          ...state.activeOnglet,
          lots: action.payload.lots.results,
          lotsPagination: action.payload.lots.pagination,
        },
        onglets: found
          ? state.onglets.map((onglet) => {
              if (onglet.id === action.payload.ongletId) {
                return {
                  ...onglet,
                  lots: action.payload.lots.results,
                  lotsPagination: action.payload.lots.pagination,
                };
              }
              return onglet;
            })
          : state.onglets,
      };
    case "FETCH_PROGRAMMES_SUCCESS":
      let foundOngletProgrammes = state.onglets.find(
        (onglet) => onglet.id === action.payload.ongletId,
      );
      return {
        ...state,
        activeOnglet: {
          ...state.activeOnglet,
          programmes: action.payload.programmes.results,
          programmesPagination: action.payload.programmes.pagination,
        },
        onglets: foundOngletProgrammes
          ? state.onglets.map((onglet) => {
              if (onglet.id === action.payload.ongletId) {
                return {
                  ...onglet,
                  programmes: action.payload.programmes.results,
                  programmesPagination: action.payload.programmes.pagination,
                };
              }
              return onglet;
            })
          : state.onglets,
      };
    // ==================================================
    case "CLOSE_ONGLET":
      return {
        ...state,
        activeOnglet: state.onglets.find((onglet) => onglet.id === "stock"),
        onglets: state.onglets.filter((onglet) => onglet.id !== action.payload),
      };

    case "SET_ACTIVE_ONGLET":
      return {
        ...state,
        activeOnglet: state.onglets.find(
          (onglet) => onglet.id === action.payload,
        ),
      };

    case "SET_ACTIVE_VIEW":
      return {
        ...state,
        activeView: action.payload,
      };

    case "SET_SINGLE_PROGRAM_ID":
      return {
        ...state,
        singleProgramId: action.payload,
      };

    case "SET_SINGLE_LOT_ID":
      return {
        ...state,
        singleLotId: action.payload,
      };

    case "SET_CURRENT_PAGE":
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload,
        },
      };

    case "ADD_OPEN_PROGRAM":
      if (state.openPrograms.includes(action.payload)) {
        return state;
      }
      return {
        ...state,
        openPrograms: [...state.openPrograms, action.payload],
      };

    case "FETCH_PROGRAMMES_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FETCH_PROGRAMMES_SUCCESS":
      return {
        ...state,
        loading: false,
        programmes: action.payload.programmes,
        pagination: action.payload.pagination,
        error: null,
      };

    case "FETCH_PROGRAMMES_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "FETCH_SINGLE_PROGRAM_REQUEST":
      return {
        ...state,
        singleProgramLoading: true,
        singleProgramError: null,
      };

    case "FETCH_SINGLE_PROGRAM_SUCCESS":
      return {
        ...state,
        singleProgramLoading: false,
        cashedSinglePrograms: [...state.cashedSinglePrograms, action.payload],
        singleProgram: action.payload,
        singleProgramError: null,
      };
    case "REPLACE_SINGLE_PROGRAM":
      return {
        ...state,
        singleProgramLoading: false,
        singleProgram: action.payload,
        singleProgramError: null,
      };
    case "FETCH_SINGLE_PROGRAM_FAILURE":
      return {
        ...state,
        singleProgramLoading: false,
        singleProgramError: action.payload,
      };

    case "FETCH_SINGLE_LOT_REQUEST":
      return {
        ...state,
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload]: true,
        },
      };

    case "FETCH_SINGLE_LOT_SUCCESS":
      return {
        ...state,
        openLotsData: {
          ...state.openLotsData,
          [action.payload.id]: action.payload,
        },
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload.id]: false,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.payload.id]: null,
        },
      };

    case "FETCH_SINGLE_LOT_FAILURE":
      return {
        ...state,
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.meta.documentId]: false,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.meta.documentId]: action.payload,
        },
      };

    case "FETCH_LOTS_REQUEST":
      return {
        ...state,
        lotsLoading: true,
        lotsError: null,
      };

    case "FETCH_LOTS_FAILURE":
      return {
        ...state,
        lotsLoading: false,
        lotsError: action.payload,
      };
    case "DEEP_SEARCH_LOADING":
      return {
        ...state,
        deepSearchLoading: true,
      };

    case "DEEP_SEARCH_SUCCESS":
      return {
        ...state,
        deepSearchLoading: false,
      };
    case "PROMOTEUR_SEARCH_LOADING":
      return {
        ...state,
        searchedPromoteurName: "",
        promoteursSearchLoading: true,
      };

    case "PROMOTEUR_SEARCH_SUCCESS":
      return {
        ...state,
        promoteursSearchLoading: false,
        promoteursSearch: action.payload.data,
        promoteursSearchError: null,
        searchedPromoteurName: action.payload.searchedPromoteurName,
      };
    case "DEEP_SEARCH_SEARCH_HISTORY":
      return {
        ...state,
        searchHistory: action.payload,
      };
    case "DEEP_SEARCH_FAILURE":
      return {
        ...state,
        deepSearchLoading: false,
        deepSearchError: action.payload,
      };
    case "CLOSE_SEARCH":
      return {
        ...state,
        deepSearchLots: [],
        deepSearchProgrammes: [],
        deepSearchLotsPagination: {},
        deepSearchProgrammesPagination: {},
      };
    case "CLOSE_PROMOTEUR_SEARCH":
      return {
        ...state,
        promoteursSearch: [],
        searchedPromoteurName: "",
      };
    default:
      return state;
  }
};

export default immobilierReducer;
